export const extractAriaProps = (props: Record<string, unknown>) => {
    const ariaProps: Record<string, string> = {};
    const restProps: Record<string, unknown> = {};

    Object.keys(props).forEach((key) => {
        const value = props[key];
        if (key.startsWith('aria-') && typeof value === 'string') {
            ariaProps[key] = value;
        } else {
            restProps[key] = value;
        }
    });

    return [ariaProps, restProps] as const;
};
